import { useId } from 'react';
import { motion } from 'framer-motion';
import { SPRING } from 'shared/components/motion/tokens';

interface PillTabsProps<T extends string> {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}

export function PillTabs<T extends string>({ options, value, onChange }: PillTabsProps<T>) {
  // layoutId único por instância: a pílula desliza entre as opções deste grupo, sem pular
  // para outro PillTabs que esteja na mesma tela.
  const pillId = useId();

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        const isSelected = option.value === value;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            aria-pressed={isSelected}
            className={`relative rounded-full px-4 py-2 text-sm font-medium transition-colors duration-200 active:scale-[0.97] ${
              isSelected ? 'text-surface' : 'bg-chip text-ink-secondary hover:bg-accent-soft hover:text-primary-dark'
            }`}
          >
            {isSelected && (
              <motion.span
                layoutId={pillId}
                transition={SPRING}
                className="absolute inset-0 rounded-full bg-primary shadow-glow"
              />
            )}
            <span className="relative">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}
